module.exports = __webpack_public_path__ + "img/monterey-rectangle-front-angle.cf360bcd.png";